import React from "react";
import { solutions } from "@/content/site";
import { PageHero, Section, CtaBand, FeatureCard, CardGrid } from "@/components/NovaKit";

export default function SolutionsFinancial() {
  const s = solutions.financial;
  return (
    <div data-testid="solutions-financial-page">
      <PageHero eyebrow="Solutions / For Financial Institutions" heading="Structured visibility, readiness, and pilot-ready business data pathways" highlight="visibility, readiness" intro={s.intro} index="05.3" />
      <Section eyebrow="Why this matters" heading="Fragmented business inputs weaken institutional workflows" highlight="institutional workflows" indexLabel="05.3.0" bg="panel">
        <p className="text-base md:text-xl leading-[1.6] text-[#0A0E1A]/85 max-w-4xl border-l-4 border-[#4F46E5] pl-6">
          {s.why}
        </p>
      </Section>
      <Section eyebrow="Recommended sequence" heading="How the four families apply to institutional use cases" highlight="institutional use cases" indexLabel="05.3.1">
        <CardGrid cols={2}>
          {s.blocks.map(([title, body], i) => (
            <FeatureCard key={title} index={`STEP · 0${i + 1}`} title={title} body={body} featured={i === 0} />
          ))}
        </CardGrid>
      </Section>
      <Section eyebrow="Outcomes" heading="What institutional teams walk away with" highlight="walk away with" indexLabel="05.3.2" bg="panel">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {s.outcomes.map((o, i) => (
            <div key={o} className="grad-border grad-border-on card-hover bg-white rounded-[20px] p-6 md:p-8 flex items-start gap-4">
              <span className="mono text-[11px] tracking-[0.22em] uppercase grad-text font-bold mt-1">{String(i + 1).padStart(2, "0")}</span>
              <p className="text-base leading-relaxed text-[#0A0E1A]/85 flex-1">{o}</p>
            </div>
          ))}
        </div>
      </Section>
      <Section eyebrow="Use cases" heading="When institutions engage with Hubinall" highlight="engage with Hubinall" indexLabel="05.3.3">
        <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-4 max-w-5xl">
          {s.useCases.map((u) => (
            <li key={u} className="flex items-start gap-3 text-base md:text-lg text-[#0A0E1A]/85 border-t hairline pt-4">
              <span className="grad-text font-bold mt-1">+</span>
              <span>{u}</span>
            </li>
          ))}
        </ul>
      </Section>
      <CtaBand heading="Let's structure an institutional pilot together." ctas={[s.cta, { label: "Request Integration Discussion", to: "/contact?form=call", variant: "secondary" }]} />
    </div>
  );
}
